import type { ReactNode } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";

interface DragContextProps {
  children: ReactNode;
}

const supportsTouch =
  typeof window !== "undefined" &&
  ("ontouchstart" in window ||
    ((window as any).DocumentTouch && document instanceof (window as any).DocumentTouch) ||
    navigator.maxTouchPoints > 0 ||
    (window as any).navigator.msMaxTouchPoints > 0);

// Known issue: preview while dragging with touch does not work - https://github.com/react-dnd/react-dnd/issues/2658
// Also: loading the TouchBackend dynamically (to avoid bundling) causes SSR issues

export default function DragContext({ children }: DragContextProps) {
  if (supportsTouch) {
    return (
      <DndProvider backend={TouchBackend} key="touch-drag-context" options={{ enableMouseEvents: true }}>
        {children}
      </DndProvider>
    );
  }
  return (
    <DndProvider backend={HTML5Backend} key="html-drag-context">
      {children}
    </DndProvider>
  );
}
